(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        if (document.querySelector('.classifiedlist') !== null) {
            const formElement = document.querySelector('.classifiedlist .classified-list-filter');
            const filterIcon = document.querySelector('.classifiedlist .filter-icon');
            let noClassifiedElement = document.querySelector('.classifiedlist .no-classifieds');
            const resetFilterElement = document.querySelector('.classifiedlist .reset-all-filter');

            const categorySelectId = 'classified-filter-category';
            const focusSelectId = 'classified-filter-focuses';
            const stateSelectId = 'classified-filter-state';
            const sizeId = 'classified-filter-size';
            const treatmentRoomsId = 'classified-filter-treatment-rooms';
            const priceId = 'classified-filter-price';
            const areaId = 'classified-filter-area';
            const keywordsId = 'classified-filter-text';
            const laboratoryId = 'classified-filter-laboratory';
            const prophylaxisId = 'classified-filter-prophylaxis';

            const categoriesInput = document.querySelector('#' + categorySelectId);
            const focusesInput = document.querySelector('#' + focusSelectId);
            const statesInput = document.querySelector('#' + stateSelectId);
            const sizeInput = document.querySelector('#' + sizeId);
            const treatmentRoomsInput = document.querySelector('#' + treatmentRoomsId);
            const priceInput = document.querySelector('#' + priceId);
            const areaInput = document.querySelector('#' + areaId);
            const keywordsInput = document.querySelector('#' + keywordsId);
            const laboratoryInput = document.querySelector('#' + laboratoryId);
            const prophylaxisInput = document.querySelector('#' + prophylaxisId);

            const columns = parseInt(document.querySelector('.classifiedlist').getAttribute('data-columns'));
            let offset = parseInt(document.querySelector('.classifiedlist').getAttribute('data-offset'));
            const limit = parseInt(document.querySelector('.classifiedlist').getAttribute('data-limit'));
            const endlessScroll = parseInt(document.querySelector('.classifiedlist').getAttribute('data-endlessscroll')) === 1;
            const selectedArea = document.querySelector('.classifiedlist').getAttribute('data-area');
            let preSelectedCategories = JSON.parse(document.querySelector('.classifiedlist').getAttribute('data-selectedcategories'));
            let preSelectedFocuses = JSON.parse(document.querySelector('.classifiedlist').getAttribute('data-selectedfocuses'));
            let preSelectedStates = JSON.parse(document.querySelector('.classifiedlist').getAttribute('data-selectedstates'));
            const ignoredIdentifier = document.querySelector('.classifiedlist').getAttribute('data-ignoredidentifer');
            let keywords = document.querySelector('.classifiedlist').getAttribute('data-searchtext');

            let loading = false;

            let currentRequest = null;

            let hasMoreClassifieds = true;

            /**
             * Fill in the dropdowns
             */
            const params = new URLSearchParams(window.location.search);

            function getParameterValues(paramName) {
                return params.getAll(`filter[${paramName}][]`).map(decodeURIComponent);
            }

            let selectedCategories = getParameterValues('category').length > 0 ? getParameterValues('category') : preSelectedCategories;
            if (categoriesInput?.length) {
                fillDropdowns(categoriesInput, selectedCategories);
            }

            let selectedFocuses = getParameterValues('focus').length > 0 ? getParameterValues('focus') : preSelectedFocuses;
            if (focusesInput?.length) {
                fillDropdowns(focusesInput, selectedFocuses);
            }

            let selectedStates = getParameterValues('state').length > 0 ? getParameterValues('state') : preSelectedStates;
            if (statesInput?.length) {
                fillDropdowns(statesInput, selectedStates);
            }

            const addOrRemoveOption = (opt, array) => {
                if (opt.selected) {
                    if (!array.includes(opt.value)) array.push(opt.value);
                } else {
                    const idx = array.indexOf(opt.value);
                    if (idx > -1) array.splice(idx, 1);
                }
            };

            /**
             * Load classifieds
             */
            const loadClassifieds = () => {
                if (loading) {
                    return;
                }
                loading = true;

                if (offset === 0) {
                    hasMoreClassifieds = true;
                }

                document.querySelector('.classifiedlist .classifiedlist-listing').classList.add('loading');

                if (noClassifiedElement !== null) {
                    noClassifiedElement.classList.add('d-none');
                }

                // javascript
                if (categoriesInput && categoriesInput.options) {
                    Array.from(categoriesInput.options).forEach((opt) => addOrRemoveOption(opt, selectedCategories));
                    updateBadges(categoriesInput);
                }
                if (focusesInput && focusesInput.options) {
                    Array.from(focusesInput.options).forEach((opt) => addOrRemoveOption(opt, selectedFocuses));
                    updateBadges(focusesInput);
                }
                if (statesInput && statesInput.options) {
                    Array.from(statesInput.options).forEach((opt) => addOrRemoveOption(opt, selectedStates));
                    updateBadges(statesInput);
                }

                updateFilterCount();

                const size = sizeInput ? sizeInput.value : '';
                const treatmentRooms = treatmentRoomsInput ? treatmentRoomsInput.value : '';
                const price = priceInput ? priceInput.value : '';
                const area = areaInput ? areaInput.value : (selectedArea ? selectedArea : '');
                const laboratory = laboratoryInput ? (laboratoryInput.checked ? true : false) : false;
                const prophylaxis = prophylaxisInput ? (prophylaxisInput.checked ? true : false) : false;
                keywords = keywordsInput ? keywordsInput.value : keywords;

                let url = window._AVENCY_BASE_actions.classifiedList;
                url += (keywords !== undefined && keywords !== '') ? '&keywords=' + keywords : '';
                url += (selectedCategories !== undefined && selectedCategories !== null) ? '&category=' + JSON.stringify(selectedCategories.filter(x => !!x)) : '';
                url += (selectedFocuses !== undefined && selectedFocuses !== null) ? '&focus=' + JSON.stringify(selectedFocuses.filter(x => !!x)) : '';
                url += (selectedStates !== undefined && selectedStates !== null) ? '&state=' + JSON.stringify(selectedStates.filter(x => !!x)) : '';
                url += (size !== '' && size !== undefined) ? '&size=' + size : '';
                url += (treatmentRooms !== '' && treatmentRooms !== undefined) ? '&treatmentRooms=' + treatmentRooms : '';
                url += (price !== '' && price !== undefined) ? '&price=' + price : '';
                url += (area !== '' && area !== undefined) ? '&area=' + area : '';
                url += laboratory ? '&laboratory=true' : '';
                url += prophylaxis ? '&prophylaxis=true' : '';
                url += (ignoredIdentifier !== '' && ignoredIdentifier !== undefined) ? '&ignoredIdentifier=' + ignoredIdentifier : '';
                url += '&columns=' + columns;
                url += '&offset=' + offset;
                url += '&limit=' + limit;

                currentRequest = new XMLHttpRequest();
                currentRequest.open('GET', url, true);
                currentRequest.onload = function () {

                    if (this.status >= 200 && this.status < 400 && offset > 0 && this.response === "") {
                        hasMoreClassifieds = false;
                    } else if (this.status >= 200 && this.status < 400 && this.response !== "") {
                        if (endlessScroll && offset > 0) {
                            hasMoreClassifieds = true;
                            document.querySelector('.classifiedlist .classifiedlist-listing').innerHTML += this.response;
                        } else {
                            document.querySelector('.classifiedlist .classifiedlist-listing').innerHTML = this.response;
                        }
                        if (formElement) {
                            formElement.setAttribute('data-filtered', true);
                        }
                    } else {
                        if (!endlessScroll || offset === 0) {
                            if (noClassifiedElement !== null) {
                                noClassifiedElement.classList.remove('d-none');
                            }
                            document.querySelector('.classifiedlist .classifiedlist-listing').innerHTML = '';
                        }
                    }
                    document.querySelector('.classifiedlist .classifiedlist-listing').classList.remove('loading');

                    loading = false;
                };
                currentRequest.send();
            };

            // Reset all filter
            if (resetFilterElement) {
                resetFilterElement.addEventListener('click', (e) => {
                    window.location = window.location.href.split("?")[0];
                });
            }

            // Load classifieds on submit
            if (formElement) {
                formElement.addEventListener("submit", (e) => {
                    e.preventDefault();
                    offset = 0;
                    if (currentRequest) {
                        currentRequest.abort();
                        currentRequest = null;
                    }
                    loading = false;
                    loadClassifieds();
                });
            }

            const updateFilterCount = () => {
                let filtersCount = 0;
                if (keywordsInput && keywordsInput.value) {
                    filtersCount++;
                }
                if (selectedCategories?.length > 0) {
                    filtersCount++;
                }
                if (selectedFocuses?.length > 0) {
                    filtersCount++;
                }
                if (selectedStates?.length > 0) {
                    filtersCount++;
                }
                if (sizeInput && sizeInput.value) {
                    filtersCount++;
                }
                if (treatmentRoomsInput && treatmentRoomsInput.value) {
                    filtersCount++;
                }
                if (priceInput && priceInput.value) {
                    filtersCount++;
                }
                if (areaInput && areaInput.value) {
                    filtersCount++;
                }
                if (laboratoryInput && laboratoryInput.checked) {
                    filtersCount++;
                }
                if (prophylaxisInput && prophylaxisInput.checked) {
                    filtersCount++;
                }
                if (filtersCount === 0) {
                    filterIcon.classList.toggle("filters-set", false);
                } else {
                    filterIcon.classList.toggle("filters-set", true);
                    filterIcon.style.setProperty("--filter-count", `"${filtersCount}"`);
                }
            };

            // Load first batch of classifieds
            loadClassifieds();

            /**
             * Check if classifieds bottom is in viewport
             *
             * @returns {boolean}
             */
            const isInViewport = () => {
                const endlessScrollElement = document.querySelector('.classifiedlist .classifiedlist-endlessscroll');
                const bounding = endlessScrollElement.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            };

            if (endlessScroll) {
                window.addEventListener(
                    "scroll",
                    () => {
                        if (isInViewport() && !loading && hasMoreClassifieds) {
                            offset += limit;
                            loadClassifieds();
                        }
                    },
                    { passive: true }
                );
            }

            const handleInputChanges = debounce(() => {
                offset = 0;
                if (currentRequest) {
                    currentRequest.abort();
                    currentRequest = null;
                }
                loading = false;
                loadClassifieds();
            }, 1000);

            [prophylaxisInput, laboratoryInput, categoriesInput, focusesInput, statesInput].forEach((element) => {
                element?.addEventListener("change", handleInputChanges);
            });

            [keywordsInput, sizeInput, treatmentRoomsInput, priceInput, areaInput].forEach((element) => {
                element?.addEventListener("input", handleInputChanges);
            });

            // Add apply-button into dropdown
            if (document.querySelector('.classifiedlist') !== null) {
                // Add apply-button into dropdown
                $('.dropdown-toggle').on('show.bs.dropdown', function (e) {
                    const applyButtonExists = $(this).parent('.filter-dropdown.show .inner.show .apply-button-container').length > 0;
                    const applyButtonText = window._AVENCY_BASE_translations.classifieds.applyButton;

                    if (!applyButtonExists) {
                        const applyButton = '<div class="apply-button-container"><div class="apply-button d-grid gap-2"><button type="button" class="btn btn-primary">' + applyButtonText + '</button></div></div>';
                        $(this).parent('.filter-dropdown').find('div.inner.show').append(applyButton);
                    }
                });
            }
        }

        function fillDropdowns(dropdown, selectedValues) {
            Array.from(dropdown[0].children).forEach(item => {
                if (selectedValues.includes(item.value)) {
                    item.selected = true;
                }
            });
        }

        function updateBadges(input) {
            if (!input) {
                return;
            }

            const options = Array.from(input.options);
            const selectedOptions = options.filter((opt) => opt.selected && opt.value !== "").map((opt) => opt.label);
            const activeFiltersElement = document.querySelector(".classifiedlist .active-filters");

            const filterGroupTemplate = document.querySelector("template#active-filters__group");
            const buttonTemplate = document.querySelector("template#active-filters__button");

            let filterGroup = document.querySelector('.active-filters__group[data-input="' + input.id + '"]');
            const filtersList = activeFiltersElement.querySelector(".active-filters__list");

            if (selectedOptions.length === 0) {
                filterGroup?.remove();
                return;
            }

            if (!filterGroup) {
                filterGroup = filterGroupTemplate.content.cloneNode(true).children[0];
                filterGroup.setAttribute("data-input", input.id);
                filterGroup.querySelector(".active-filters__label").innerText = `${input.getAttribute(
                    "title"
                )}:`;
                filtersList.appendChild(filterGroup);
            }
            const existingButtons = filterGroup.querySelectorAll("button.filter-value");
            existingButtons.forEach((button) => button.remove());

            selectedOptions.forEach((label) => {
                const button = buttonTemplate.content.cloneNode(true).children[0];
                button.querySelector(".filter-value__label").innerText = label;
                button.addEventListener("click", () => {
                    const selected = [];
                    Array.from(input.options).forEach((opt) => {
                        if (opt.label === label) {
                            opt.selected = false;
                            input.dispatchEvent(new Event('change'));
                        }
                        if (opt.selected) {
                            selected.push(opt.value)
                        }
                    });
                });
                filterGroup.appendChild(button);
            });
        }

        function debounce(callback, wait) {
            let timeoutId = null;
            return (...args) => {
                window.clearTimeout(timeoutId);
                timeoutId = window.setTimeout(() => {
                    callback(...args);
                }, wait);
            };
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
